module.exports = __webpack_public_path__ + "media/images/photo/top/plan/plan1-c418ef5613873fd362fc5b9c0db3728c.jpg";